<script lang="ts">
  import { getContext } from 'svelte';
  import { field, form } from 'svelte-forms';
  import { required } from 'svelte-forms/validators';
  import Loading from '../../../etc/loader.svelte';
  import OperationCompleteModal from '../../../etc/modal/invitation/umobiled/OperationCompleteModal.svelte';
  import RepositoryFactory, { INVITATION_UMOBILED } from '../../../repositories/RepositoryFactory';
  import StringUtil from '../../../util/StringUtil';

  const { open, close }: any = getContext('simple-modal');

  // input項目
  const mailAddress = field('mailAddress', '', [required()]);
  const myForm = form(mailAddress);

  let isLoading = false;
  let mailAddressErrorMessage: string = '';

  const handleRegistration = async () => {
    mailAddressErrorMessage = '';
    let isFormValid = false;
    await myForm.validate().then(() => {
      isFormValid = $myForm.valid;
    });
    if (!isFormValid) {
      return;
    }

    if (!StringUtil.isMailAddress($mailAddress.value)) {
      mailAddressErrorMessage = '正しいメールアドレスを入力してください';
      return;
    }

    if (isCarrierDomain($mailAddress.value)) {
      mailAddressErrorMessage = 'キャリアのメールアドレスは使用できません';
      return;
    }

    isLoading = true;

    const repository = RepositoryFactory[INVITATION_UMOBILED];
    repository
      .notifyUrl({ email: $mailAddress.value })
      .then(() => {
        isLoading = false;
        showSuccessedModal();
      })
      .catch((error) => {
        isLoading = false;
        mailAddressErrorMessage = '予期せぬエラーが発生しました。時間をおいて再度お試しください。';
      });
  };

  const isCarrierDomain = (value: string): boolean => {
    // 事前にisMailAddressにて@についても検証するためsplitのlength検証はしない
    return [
      'docomo.ne.jp',
      'ezweb.ne.jp',
      'au.com',
      'willcom.com',
      'y-mobile.ne.jp',
      'emobile.ne.jp',
      'ymobile1.ne.jp',
      'ymobile.ne.jp',
      'softbank.ne.jp',
      'vodafone.ne.jp',
      'i.softbank.jp',
      'disney.ne.jp'
    ].includes(value.split('@')[1]);
  };

  const showSuccessedModal = () => {
    open(
      OperationCompleteModal,
      {
        modalTitle: 'お申込みページURLを記載したメールをお送りいたしました',
        modalMessage:
          'お申込みページURLを記載したメールをお送りいたしました。メールのURLよりお手続きを行ってください。',
        handleCloseEvent: () => {
          close();
          location.reload();
        }
      },
      {
        closeButton: false,
        closeOnEsc: false,
        closeOnOuterClick: false
      }
    );
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    e.key === 'Enter' && handleRegistration();
  };

  const handleSubmit = (e: Event) => {
    e.preventDefault();
  };
</script>

{#if isLoading}
  <Loading />
{/if}

<!-- 本体 -->
<div class="flex flex-col justify-between items-center login-background">
  <header class="container top-0 z-0">
    <div class="justify-between items-center" style="height:56px">
      <img style="height:36px" class="object-none w-full" src="/image/unext_communication_logo.svg" alt="logo" />
    </div>
  </header>

  <main class="container mt-10 mb-auto">
    <div class="flex justify-center text-2xl">U-mobile(d)申込ページへようこそ</div>

    <div class="flex justify-center mt-5">
      <div class="content-center shadow-sm p-2 lg:w-1/2 w-full">
        <div class="mb:font-sm w-full">
          <ul class="list-none">
            <li>
              <p>U-mobile MAX/U-mobile Sをご利用いただいていた方向けの特別なオファーをご用意いたしました。</p>
            </li>
            <li>
              <p>以下のものをお手元にご用意の上、お手続きにお進みください。</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="flex justify-center mt-2">
      <div class="content-center shadow-sm p-5 infomation-background lg:w-1/2 w-full">
        <div class="content-help-title-xl">U-mobile MAX/U-mobile S ご利用者向け特別オファー</div>

        <div class="mt-2">
          <p class="content-help-title inline-flex items-center">
            <svg
              class="h-4 w-4 text-gray-900 mr-1"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" /> <polyline points="9 11 12 14 20 6" />
              <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" /></svg
            >
            <span>初期費用無料</span>
          </p>
          <p class="content-help-text">登録事務手数料(3,300円)、SIM発行手数料(433円）が無料</p>
        </div>

        <div class="mt-2">
          <p class="content-help-title inline-flex items-center">
            <svg
              class="h-4 w-4 text-gray-900 mr-1"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" /> <polyline points="9 11 12 14 20 6" />
              <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" /></svg
            >
            <span>プラン ※月額利用料が最大3カ月分無料</span>
          </p>
          <p class="content-help-text">開通月(契約開始日が属する月)から2025年9月までの各プランの月額基本使用料が無料</p>
        </div>
      </div>
    </div>

    <div class="flex justify-center mt-1">
      <div class="content-center shadow-sm p-2 lg:w-1/2 w-full">
        <ul class="list-none">
          <li>
            <p>※本オファーにてお申込みいただけるプランは以下のものとなります</p>
          </li>
        </ul>
        <ul class="list-disc ml-4 mt-2">
          <li>
            <p>U-mobile MAX 通話プラス25Gをご契約いただいていた方</p>
          </li>
        </ul>
        <ul class="list-none ml-4">
          <li>
            <p>移管専用25GB通話プラス(「U-mobileMAX25GB通話プラス」対応)／3,168円/月</p>
          </li>
        </ul>
        <ul class="list-disc ml-4 mt-2">
          <li>
            <p>U-mobile MAX データ専用25G、U-mobile S データ専用(1G/3G/7G/30G)をご契約いただいていた方</p>
          </li>
        </ul>
        <ul class="list-none ml-4">
          <li>
            <p>移管専用1GBデータ専用(「U-mobileSデータ通信専⽤1GB」対応)／968/月</p>
          </li>
          <li>
            <p>移管専用3GBデータ専用(「U-mobileSデータ通信専⽤3GB」対応)／1,738/月</p>
          </li>
          <li>
            <p>移管専用7GBデータ専用(「U-mobileSデータ通信専⽤7GB」対応)／3,278/月</p>
          </li>
          <li>
            <p>移管専用30GBデータ専用(「U-mobileSデータ通信専⽤30GB」対応)／5,478/月</p>
          </li>
          <li>
            <p>移管専用25GBデータ専用(「U-mobileMAX25GBデータ専用」対応)／2,618/月</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="flex justify-center mt-5">
      <div class="content-center shadow-sm p-5 warning-background lg:w-1/2 w-full">
        <div class="content-help-title-xl">お申込にあたりご用意いただくもの</div>
        <div class="mt-5">
          <p class="content-help-title inline-flex items-center">
            <svg
              class="h-4 w-4 text-gray-900 mr-1"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" /> <polyline points="9 11 12 14 20 6" />
              <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" /></svg
            >
            <span>有効なメールアドレス</span>
          </p>
          <p class="content-help-text">
            下記入力欄に有効なメールアドレスをご登録いただくとお申込みページURLを記載したメールをお送りいたしますので、そちらからお手続きを行ってください
          </p>
        </div>

        <div class="mt-2">
          <p class="content-help-title inline-flex items-center">
            <svg
              class="h-4 w-4 text-gray-900 mr-1"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" /> <polyline points="9 11 12 14 20 6" />
              <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" /></svg
            >
            <span>特別オファー用招待コード</span>
          </p>
          <ul class="list-none">
            <li>
              <p class="content-help-text">
                該当のお客様には当社より事前に招待コードをメールにてお送りいたしております。
              </p>
            </li>
            <li><p class="content-help-text">お申込みに必要となりますのでご準備願います</p></li>
          </ul>
        </div>

        <div class="mt-2">
          <p class="content-help-title inline-flex items-center">
            <svg
              class="h-4 w-4 text-gray-900 mr-1"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" /> <polyline points="9 11 12 14 20 6" />
              <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" /></svg
            >
            <span>MNP予約番号</span>
          </p>
          <ul class="list-none">
            <li><p class="content-help-text">音声プランのお申込み対象者の方は必ずMNP予約番号が必要となります。</p></li>
            <li><p class="content-help-text">U-mobileMAXのマイページにて事前にMNP予約番号を取得をお願いします。</p></li>
            <li><p class="content-help-text">MNP予約番号の有効期限は10日以上残っていないと利用できません。</p></li>
          </ul>
        </div>

        <div class="mt-2">
          <p class="content-help-title inline-flex items-center">
            <svg
              class="h-4 w-4 text-gray-900 mr-1"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" /> <polyline points="9 11 12 14 20 6" />
              <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" /></svg
            >
            <span>クレジットカード</span>
          </p>
          <p class="content-help-text">お支払いは、ご契約者のご本人様名義のクレジットカードのみになります。</p>
        </div>
      </div>
    </div>

    <div class="flex justify-center my-10">
      <div class="content-center shadow-sm p-5 form-background lg:w-1/2 w-full">
        <div class="content-help-title-xl">メールアドレスの登録</div>
        <form on:submit={handleSubmit}>
          <div class="flex flex-row mt-4 items-center space-x-4">
            <div class="basis-3/4">
              <input
                type="email"
                id="mailAddress"
                name="mailAddress"
                autocomplete="off"
                class="block p-3"
                placeholder="例) sample@umobile.jp"
                bind:value={$mailAddress.value}
                on:keypress={handleKeyPress}
                required
              />
            </div>
            <div class="basis-1/4">
              <button type="button" class="tracking-widest form-button" on:click={handleRegistration}>登録</button>
            </div>
          </div>
          <div class="flex items-center">
            {#if $myForm.hasError('mailAddress.required')}
              <p class="helper-text">メールアドレスを入力してください</p>
            {/if}
            {#if mailAddressErrorMessage}
              <p class="helper-text">{mailAddressErrorMessage}</p>
            {/if}
          </div>
        </form>
      </div>
    </div>
  </main>

  <footer class="container" />
</div>

<style lang="postcss">
  .login-background {
    background-color: white;
  }

  .content-help-title-xl {
    @apply text-xl font-semibold text-gray-900;
  }

  .content-help-title {
    @apply text-lg font-semibold text-gray-900;
  }

  .content-help-text {
    @apply text-sm font-normal text-gray-900;
  }

  input[type='email'] {
    font-size: 14px;
    color: rgba(0, 10, 23, 1);
    background-color: rgba(1, 6, 13, 0.06);
    @apply min-h-12 min-w-full focus:ring-0 focus:ring-blue-200 focus:border-transparent;
  }

  .infomation-background {
    background-color: rgba(14, 165, 233, 0.12);
  }

  .warning-background {
    background-color: rgba(0, 0, 0, 0.12);
  }

  .form-background {
    background-color: rgba(0, 0, 0, 0.02);
  }

  .form-button {
    @apply text-center text-sm font-medium rounded-none text-white bg-[#0fb9f5] h-12 min-w-full;
  }
  .form-button:hover {
    text-decoration: none;
    -webkit-filter: brightness(1.1);
    filter: brightness(1.1);
  }
  .helper-text {
    @apply text-xs text-red-500  mt-2;
  }
</style>
